import type {Ref} from 'vue';
import {email, required, requiredIf, withMessage} from '@regle/rules';
import {storeToRefs} from 'pinia';
import {useTranslation} from '#imports';
import {useRegle, validateForm} from '@malt/forms';
import {useExpenseValidationStore} from '../stores';
import type {ExpenseClientCompanyBillingInfoParam} from '../types';

const FORM_ID = 'client-company-billing-infos-validation-form';

export function useClientCompanyBillingInfosValidationForm(
    clientCompanyBillingInfoValidationData: Ref<ExpenseClientCompanyBillingInfoParam & {purchaseOrderNumber?: string}>,
) {
    const {t} = useTranslation();

    const expenseValidationStore = useExpenseValidationStore();
    const {batchExpenseItem} = storeToRefs(expenseValidationStore);

    const {r$} = useRegle(clientCompanyBillingInfoValidationData, {
        billingContact: {email, required},
        purchaseOrderNumber: {
            required: withMessage(
                requiredIf(() => !batchExpenseItem.value.punchoutDetails?.isPunchoutEnabled && batchExpenseItem.value.clientPurchaseOrderRequired),
                () => t('projectclient.billinginformation.invoice.purchaseorder.required'),
            ),
        },
    });

    async function triggerValidation(): Promise<boolean> {
        const {valid} = await validateForm(r$, {formId: FORM_ID});
        return valid;
    }

    return {
        r$,
        formId: FORM_ID,
        validateForm: triggerValidation,
    };
}
